import adminApiWrapper from "@/server/admin-server";

export async function updateIpRestrictionSettings({ enableRestrictedIP, allowedRules }) {
  return await adminApiWrapper("put", "/v1/organization-settings/my/customized-permissions/restricted-ip", {
    enableRestrictedIP,
    allowedRules,
  });
}
